import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
 
@Directive({
  selector: '[appUppercase]'
})
export class UppercaseDirective {
 
  constructor(private el: ElementRef, private ngControl: NgControl) { }
 
  @HostListener('input', ['$event']) onInput(event: Event) {
    const inputValue = this.ngControl.value.toUpperCase();
    this.ngControl.control.setValue(inputValue, { emitEvent: false });
  }
}